//是否无地形
export function hasTerrain(viewer) {
    var _ellipsoid = new Cesium.EllipsoidTerrainProvider({
        ellipsoid: Cesium.Ellipsoid.WGS84
    });
    return !(viewer.terrainProvider == _ellipsoid || viewer.terrainProvider instanceof Cesium.EllipsoidTerrainProvider);
}

//计算坡度值
export function computeSlope(normaA, normaB) {
    var slopeAngle = Cesium.Cartesian3.angleBetween(normaA, normaB);
    return Cesium.Math.toDegrees(slopeAngle);
}

//计算出三角面的法向量
export function computeSurfaceNormal(vertex1, vertex2, vertex3) {
    const edge1 = Cesium.Cartesian3.subtract(vertex2, vertex1, new Cesium.Cartesian3());
    const edge2 = Cesium.Cartesian3.subtract(vertex3, vertex1, new Cesium.Cartesian3());
    const normal = Cesium.Cartesian3.cross(edge1, edge2, new Cesium.Cartesian3());
    Cesium.Cartesian3.normalize(normal, normal);
    return normal;
}
//114.25 37 39
//30.27 10 84
  